import { appLanguages, appLocales, Locales } from "@/lib/i18n";
import { actions, segments } from "@/locales/segment";

export function __(str: string, lang: Locales) {
  const dictionary: { [key: string]: string } = appLanguages[lang]?.locales;

  if (!dictionary) {
    return str;
  }

  const translated = dictionary[str];
  const isLocal = process.env.NODE_ENV === "development";

  return translated || (isLocal && lang !== appLocales.defaultNs ? "⚠️ Missing `" + lang + "`: " : "") + str;
}

export function getPermalink(locale: Locales, segment: string, action?: string) {
  let link = ``;

  if (locale !== appLocales.defaultLocale) {
    link += `/${locale}`;
  }

  const segmentKey = segments[locale]?.[segment];

  if (segmentKey) {
    link += `/${segmentKey}`;
  }

  if (action) {
    const actionKey = actions[locale]?.[action];

    if (actionKey) {
      link += `/${actionKey}`;
    }
  }

  return link;
}
